import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import SelectComponent from '#app/Component/SelectComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import Modal from '#app/View/ClientService/OrderClientLitige/components/Modal';
import { Option } from '#app/typings/utils';

type Props = {
  reload: () => void;
  onClose: () => void;
  countryCode?: string;
};

const RefundShippingModal: React.FC<Props> = ({ onClose, reload, countryCode }) => {
  const params = useParams<{ uuid: string }>();
  const uuid = params.uuid as string;
  const [loading, setLoading] = useState<boolean>(false);
  const [optionTva, setOptionTva] = useState<Option[]>([]);

  const [form, setForm] = useState<Form>({
    tva: {
      name: 'tva',
      label: 'TVA',
      textHelper: 'Selectionnez une TVA.',
      type: 'integer',
      options: { validation: ['required'] },
    },
    refundPrice: {
      name: 'refundPrice',
      label: 'Montant TTC',
      textHelper: "Remboursement d'un montant TTC",
      type: 'float',
      options: { validation: ['required'] },
    },
  });
  const handler = initFormHandler(form, setForm);
  useEffect(() => {
    ApiHandler.get<Option[]>({ route: 'api_select_tva', data: { countryCode: countryCode ?? '' } }, (response) => {
      setOptionTva(response.data ?? []);
      handler.setValue('tva', response?.data?.[0].value);
    });

    handler.start();
  }, []);

  const handleSubmit = () => {
    if (handler.checkError() > 0) {
      return;
    }
    setLoading(true);

    const data = handler.getData();
    ApiHandler.post(
      {
        route: 'api_client_service_order_client_litige_refund_amount',
        params: { uuid },
        data: {
          tva: data.tva,
          refundPrice: data.refundPrice,
        },
      },
      (response) => {
        if (response.status === 200) {
          dispatch(
            SnackbarOpen({
              text: 'Demande de remboursement créée avec succès.',
              variant: 'success',
            }),
          );
          reload();
        } else {
          dispatch(
            SnackbarOpen({
              text: response?.error?.message || "Une erreur inattendue s'est produite.",
              variant: 'error',
            }),
          );
        }
        setLoading(false);
        onClose();
      },
    );
  };

  return (
    <Modal title="Remboursement" onClose={onClose} onSubmit={handleSubmit} loading={loading}>
      <SelectComponent id="tva" options={optionTva} handler={handler} />
      <TextFieldComponent id="refundPrice" handler={handler} />
    </Modal>
  );
};

export default RefundShippingModal;
